import { render } from "./RecordItem.vue?vue&type=template&id=2cf86c6e"
import script from "./RecordItem.vue?vue&type=script&lang=js"
export * from "./RecordItem.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__